var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1315,
    height: 1262,
    viewBox: "0 0 1315 1262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_648_269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.982 973.344C187.636 974.143 180.6 976.339 176.461 978.136C143.868 992.612 126.795 1025.96 125.14 1078.67C124.209 1107.32 127.933 1131.38 136.211 1151.55C141.902 1165.43 146.972 1173.01 156.284 1182C169.218 1194.28 181.841 1199.47 199.224 1199.47C215.159 1199.47 232.128 1192.88 246.096 1181.3C249.408 1178.6 252.512 1176.61 253.132 1177.01C253.753 1177.41 256.547 1182.1 259.444 1187.59L264.618 1197.57L271.55 1197.27L278.483 1196.97L278.793 1143.76L279 1090.65L241.026 1090.85L202.949 1091.15L202.639 1105.52C202.432 1115.21 202.742 1120.3 203.57 1121.2C204.501 1122.3 208.951 1122.6 224.782 1122.6H244.855V1126.29C244.751 1136.77 239.267 1149.95 232.025 1156.94C225.092 1163.63 217.228 1166.82 206.571 1167.32C198.397 1167.72 196.948 1167.52 191.154 1165.03C176.254 1158.54 166.528 1141.37 162.596 1114.41C159.492 1093.44 161.251 1054.31 165.907 1038.74C173.564 1013.28 191.05 999.301 210.399 1003.19C221.678 1005.39 229.438 1012.58 235.129 1026.16C236.784 1029.95 238.75 1033.24 239.578 1033.54C240.716 1033.94 262.031 1030.05 268.963 1028.15C271.447 1027.45 271.24 1024.06 268.239 1016.47C260.996 998.003 247.131 983.927 229.334 977.038C218.47 972.845 203.26 971.347 191.982 973.344Z",
    fill: "url(#paint0_linear_648_269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.691 982.897C838.296 983.299 838 990.539 838 999.085V1014.47L856.549 1014.27L875 1013.97V998.381V982.797L857.141 982.495C847.373 982.394 839.085 982.595 838.691 982.897Z",
    fill: "url(#paint1_linear_648_269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.55 984.573C1161.06 987.495 1153.07 995.457 1150.34 1002.92C1145.58 1015.51 1148.21 1029.72 1157.01 1038.69C1164.6 1046.35 1169.86 1048.47 1182 1048.47C1193.94 1048.47 1198.09 1046.76 1205.88 1038.79C1222.06 1022.27 1215.79 992.635 1194.34 984.674C1186.66 981.751 1176.03 981.751 1168.55 984.573ZM1190.6 988.1C1198.19 990.317 1206.99 999.085 1209.21 1006.64C1212.35 1017.33 1210.43 1026.7 1203.35 1034.56C1196.87 1041.72 1190.9 1044.44 1181.5 1044.44C1173 1044.44 1167.54 1042.32 1161.47 1036.58C1155.5 1030.93 1152.77 1024.38 1152.77 1015.71C1152.77 1006.44 1155.7 999.992 1162.88 993.643C1170.57 986.891 1180.08 984.976 1190.6 988.1Z",
    fill: "url(#paint2_linear_648_269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.24 995.802C1169.04 996.52 1168.94 1005.64 1169.04 1015.99L1169.35 1034.96H1172.91H1176.47L1176.78 1026.45L1177.08 1018.04H1180.03C1184.41 1018.04 1186.14 1020.4 1186.14 1026.76C1186.14 1034.44 1186.75 1035.47 1191.23 1035.47H1195L1194.59 1030.04C1193.88 1020.71 1193.27 1018.04 1191.23 1016.81C1189.4 1015.69 1189.4 1015.48 1191.84 1012.61C1193.57 1010.56 1194.29 1008.41 1194.29 1005.64C1194.29 1000.21 1192.86 997.647 1188.69 995.905C1184.21 994.06 1169.96 993.957 1169.24 995.802ZM1184.62 1002.26C1187.26 1004.92 1186.24 1010.05 1182.78 1011.69C1178.2 1013.94 1176.98 1012.71 1176.98 1006.26C1176.98 1000.72 1176.98 1000.62 1179.93 1000.62C1181.56 1000.62 1183.7 1001.34 1184.62 1002.26Z",
    fill: "url(#paint3_linear_648_269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.953 1002.76L946.438 1015.34L946.536 1031.92V1048.59H936.954C930.794 1048.59 926.981 1049 926.199 1049.82C924.537 1051.56 924.634 1068.44 926.297 1069.87C926.981 1070.49 931.772 1071.2 936.856 1071.3L946.047 1071.61L946.536 1122.76C946.927 1156.73 947.416 1175.04 948.198 1177.19C950.936 1185.17 956.704 1191.21 965.797 1195.71C970.882 1198.16 972.544 1198.47 982.223 1198.47C994.054 1198.47 1006.86 1195.5 1011.56 1191.61C1013.9 1189.67 1014 1189.26 1014 1176.98C1014 1169.52 1013.61 1164.09 1013.02 1163.69C1012.44 1163.28 1007.64 1164.91 1002.27 1167.16C992.099 1171.56 983.886 1172.69 980.659 1170.03C976.944 1167.06 976.846 1165.42 976.846 1117.75V1071.2L988.872 1070.9L1000.8 1070.59L1001.09 1060.46C1001.29 1052.99 1001 1050.03 1000.12 1049.41C999.432 1049 994.152 1048.59 988.383 1048.59H977.824L977.628 1019.64L977.335 990.792L974.401 990.485C971.859 990.28 969.806 991.917 958.953 1002.76Z",
    fill: "url(#paint4_linear_648_269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.488 1034.03C665.922 1036.85 659.98 1039.58 659.355 1040.18C658.313 1040.89 658 1062.35 658 1141.17C658 1196.29 658.313 1241.95 658.625 1242.86C659.147 1244.27 661.44 1244.47 673.531 1244.47C683.224 1244.47 688.227 1244.07 689.061 1243.26C689.999 1242.35 690.312 1232.78 690.312 1206.78L690.416 1171.4L692.709 1174.42C701.048 1185.41 712.513 1192.97 724.187 1194.98C738.675 1197.6 755.874 1189.84 766.297 1176.04C780.576 1156.99 786.935 1117.38 780.472 1086.74C774.01 1055.8 761.919 1039.07 741.385 1032.92C726.48 1028.39 711.679 1032.12 701.152 1043.1C697.087 1047.34 692.188 1054.39 689.686 1059.53L687.706 1063.56L687.393 1046.73C687.185 1034.13 686.768 1029.9 685.726 1029.5C684.996 1029.2 679.055 1031.31 672.488 1034.03ZM731.796 1059.93C739.196 1063.66 742.845 1068.8 746.388 1080.7C752.955 1102.26 751.287 1137.13 743.053 1154.07C739.822 1160.72 733.255 1166.56 728.148 1167.47C719.392 1169.08 707.302 1164.65 701.882 1157.9C693.543 1147.41 690.416 1137.34 689.582 1118.49C689.061 1106.6 689.269 1103.67 691.354 1094.81C695.419 1077.67 704.383 1063.46 713.764 1059.53C718.559 1057.52 727.314 1057.72 731.796 1059.93Z",
    fill: "url(#paint5_linear_648_269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.631 1038.48L352 1043.87V1118.12V1192.47H367.06H382.119L382.605 1148.3L383.091 1104.13L388.435 1098.44C401.065 1085.14 412.53 1079.65 426.327 1080.25L433.614 1080.55L433.905 1057.96C434.197 1030.88 434.391 1031.28 425.258 1036.08C421.955 1037.78 416.708 1041.28 413.599 1043.67C405.923 1049.77 393.487 1064.36 386.88 1075.15C383.868 1080.05 381.051 1084.05 380.565 1084.05C380.079 1084.05 379.593 1072.75 379.496 1058.86C379.302 1043.17 378.816 1033.68 378.233 1033.48C377.747 1033.28 371.626 1035.58 364.631 1038.48Z",
    fill: "url(#paint6_linear_648_269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.031 1032.5C515.818 1034.23 486.579 1047.01 485.377 1050.28C484.576 1052.23 496.092 1072.67 498.194 1073.08C499.096 1073.29 501.799 1072.16 504.202 1070.63C511.712 1065.72 526.131 1060 535.143 1058.36C543.054 1056.83 544.255 1056.83 550.063 1058.36C561.278 1061.33 563.08 1064.39 563.08 1081.26V1093.32L550.864 1094.45C525.13 1096.9 507.507 1103.75 494.489 1116.43C486.078 1124.5 481.873 1131.66 478.869 1142.29C472.861 1164.37 481.673 1185.43 500.497 1194.02C508.208 1197.5 524.529 1198.01 534.242 1194.94C543.054 1192.28 550.964 1187.48 559.976 1179.5L566.785 1173.58L568.888 1177.97C573.293 1187.38 581.104 1193.72 590.616 1195.76C599.728 1197.7 605.936 1198.01 607.138 1196.58C607.839 1195.66 608.139 1190.95 607.939 1183.59C607.639 1172.04 607.639 1171.94 605.135 1171.63C600.229 1171.02 597.525 1169.28 596.324 1165.91C595.423 1163.56 595.122 1149.76 595.122 1117.66C595.122 1089.44 594.722 1070.32 594.021 1066.54C589.815 1043.44 571.892 1031.17 542.653 1031.47C536.545 1031.58 529.035 1031.99 526.031 1032.5ZM563.08 1133.91V1153.64L559.876 1156.71C549.562 1166.42 536.144 1173.47 528.234 1173.47C517.42 1173.37 508.007 1162.94 508.007 1150.88C508.007 1145.87 511.011 1137.69 514.616 1132.89C518.121 1128.18 527.633 1121.95 535.343 1119.39C540.75 1117.55 555.77 1114.59 561.378 1114.28C562.98 1114.18 563.08 1115.71 563.08 1133.91Z",
    fill: "url(#paint7_linear_648_269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.5 1037.03C1086.93 1037.93 1075.89 1042.73 1070.93 1046.44C1056.15 1057.35 1050.38 1076.48 1056.45 1094.21C1061.11 1107.83 1070.12 1115.54 1098.07 1129.96C1115.58 1138.97 1119.23 1141.57 1121.96 1146.68C1124.29 1151.19 1124.39 1154.79 1122.37 1160.6C1118.42 1171.41 1106.98 1176.92 1093.41 1174.52C1086.12 1173.22 1080.55 1170.61 1071.34 1164.2C1067.79 1161.7 1064.35 1159.9 1063.74 1160.1C1062.33 1160.7 1052 1179.93 1052 1181.93C1052 1185.63 1072.76 1195.55 1084.8 1197.65C1088.95 1198.35 1096.45 1198.65 1103.03 1198.35C1112.65 1197.95 1115.38 1197.35 1121.66 1194.75C1135.73 1188.94 1144.64 1179.93 1149.3 1167.01C1154.97 1151.19 1151.52 1132.56 1140.79 1121.64C1134.92 1115.64 1128.74 1111.83 1107.89 1101.52C1084.3 1089.8 1080.35 1085.79 1081.66 1074.68C1082.27 1068.97 1084.8 1065.47 1090.57 1062.56C1094.42 1060.56 1096.14 1060.26 1103.63 1060.56C1113.25 1060.96 1120.24 1063.56 1129.15 1069.97C1131.88 1071.87 1134.92 1073.38 1135.83 1073.18C1137.75 1072.78 1146.26 1051.75 1145.35 1049.54C1144.54 1047.34 1128.14 1040.13 1119.53 1038.23C1111.94 1036.52 1098.98 1035.92 1092.5 1037.03Z",
    fill: "url(#paint8_linear_648_269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.265 1037.09C842.292 1037.49 842 1054.1 842 1115.48V1193.47L856.891 1193.17L871.685 1192.86L871.977 1115.98C872.074 1060.03 871.88 1038.7 871.101 1037.8C870.225 1036.69 866.916 1036.39 857.183 1036.49C850.176 1036.49 843.849 1036.79 843.265 1037.09Z",
    fill: "url(#paint9_linear_648_269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.464 557.58C989.163 561.769 987.96 570.546 986.857 577.128C976.329 638.066 951.063 694.217 912.06 742.988C900.128 757.849 870.851 786.872 855.511 798.94C802.471 840.729 741.008 866.56 675.135 874.739C668.818 875.537 663.203 876.135 662.802 876.135C662.401 876.135 662 887.604 662 901.567C662 915.53 662.301 927 662.802 927C663.203 927 669.52 926.302 676.939 925.504C865.036 904.56 1016.23 755.854 1039.5 568.651C1040.3 561.968 1041 555.087 1041 553.291V550H1015.53H990.166L989.464 557.58Z",
    fill: "url(#paint10_linear_648_269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.464 475.42C989.163 471.231 987.96 462.454 986.857 455.872C976.329 394.934 951.063 338.783 912.06 290.012C900.128 275.151 870.851 246.128 855.511 234.06C802.471 192.271 741.008 166.44 675.135 158.261C668.818 157.463 663.203 156.865 662.802 156.865C662.401 156.865 662 145.396 662 131.433C662 117.47 662.301 106 662.802 106C663.203 106 669.52 106.698 676.939 107.496C865.036 128.44 1016.23 277.146 1039.5 464.349C1040.3 471.032 1041 477.913 1041 479.709V483H1015.53H990.166L989.464 475.42Z",
    fill: "url(#paint11_linear_648_269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.808 557.58C271.11 561.769 272.32 570.546 273.429 577.128C284.012 638.066 309.412 694.217 348.621 742.988C360.615 757.849 390.047 786.872 405.468 798.94C458.788 840.729 520.575 866.56 586.796 874.739C593.146 875.537 598.79 876.135 599.194 876.135C599.597 876.135 600 887.604 600 901.567C600 915.53 599.698 927 599.194 927C598.79 927 592.44 926.302 584.982 925.504C395.893 904.56 243.896 755.854 220.512 568.651C219.706 561.968 219 555.087 219 553.291V550H244.602H270.102L270.808 557.58Z",
    fill: "url(#paint12_linear_648_269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.808 475.42C271.11 471.231 272.32 462.454 273.429 455.872C284.012 394.934 309.412 338.783 348.621 290.012C360.615 275.151 390.047 246.128 405.468 234.06C458.788 192.271 520.575 166.44 586.796 158.261C593.146 157.463 598.79 156.865 599.194 156.865C599.597 156.865 600 145.396 600 131.433C600 117.47 599.698 106 599.194 106C598.79 106 592.44 106.698 584.982 107.496C395.893 128.44 243.896 277.146 220.512 464.349C219.706 471.032 219 477.913 219 479.709V483H244.602H270.102L270.808 475.42Z",
    fill: "url(#paint13_linear_648_269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.198 337.667C674.67 337.667 709.72 376.782 719.182 419.344L676.239 428.443C673.659 420.667 669.335 408.048 660.976 397.271C652.389 386.202 639.535 377.06 619.988 377.06C613.858 377.06 601.972 378.246 589.562 386.534C577.144 394.828 564.274 410.184 556.1 438.394C547.231 468.461 547.235 514.901 547.235 516.291C547.235 553.308 551.423 588.537 565.439 617.694L565.44 617.696C574.109 635.619 585.496 645.093 595.983 650.074C606.458 655.05 615.989 655.522 620.919 655.522C646.759 655.522 663.202 640.864 668.383 635.175L668.389 635.168L668.396 635.16C686.693 613.91 687.624 595.446 688.555 572.493L688.583 571.799H622.516V529.596H732.333V693.588H716.671L706.157 672.349C704.057 667.886 702.168 664.783 700.424 662.785C698.685 660.793 697.006 659.807 695.33 659.807C693.282 659.807 690.818 660.82 688.882 662.281L688.844 662.31L688.811 662.343C686.94 664.225 683.714 667.472 681.424 669.316L681.416 669.322L681.408 669.329C672.114 677.281 649.49 697.333 613.478 697.333C606.511 697.333 595.328 697.331 582.302 692.854C569.487 688.45 554.855 679.703 540.724 662.296L540.052 661.461L540.047 661.455C524.094 641.906 514.242 615.92 508.382 589.99C502.524 564.068 500.667 538.255 500.667 519.1C500.667 479.342 506.713 428.467 528.01 393.05L528.013 393.046C555.303 346.955 597.37 337.667 617.198 337.667Z",
    fill: "url(#paint14_linear_648_269)",
    stroke: "url(#paint15_linear_648_269)",
    strokeWidth: 1.33333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_648_269",
    x1: 202,
    y1: 1199.47,
    x2: 202,
    y2: 972.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE27F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_648_269",
    x1: 856.5,
    y1: 1014.47,
    x2: 856.5,
    y2: 982.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE27F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_648_269",
    x1: 1181.5,
    y1: 1048.47,
    x2: 1181.5,
    y2: 982.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE27F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_648_269",
    x1: 1182,
    y1: 1035.47,
    x2: 1182,
    y2: 994.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE27F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_648_269",
    x1: 969.5,
    y1: 1198.47,
    x2: 969.5,
    y2: 990.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE27F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_648_269",
    x1: 720.5,
    y1: 1244.47,
    x2: 720.5,
    y2: 1029.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE27F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_648_269",
    x1: 393,
    y1: 1192.47,
    x2: 393,
    y2: 1033.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE27F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_648_269",
    x1: 542.5,
    y1: 1197.47,
    x2: 542.5,
    y2: 1031.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE27F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_648_269",
    x1: 1102,
    y1: 1198.47,
    x2: 1102,
    y2: 1036.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE27F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_648_269",
    x1: 857,
    y1: 1193.47,
    x2: 857,
    y2: 1036.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE27F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_648_269",
    x1: 851.5,
    y1: 927,
    x2: 851.5,
    y2: 550,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE27F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_648_269",
    x1: 851.5,
    y1: 106,
    x2: 851.5,
    y2: 483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE27F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_648_269",
    x1: 409.5,
    y1: 927,
    x2: 409.5,
    y2: 550,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE27F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_648_269",
    x1: 409.5,
    y1: 106,
    x2: 409.5,
    y2: 483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE27F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_648_269",
    x1: 616.5,
    y1: 337,
    x2: 616.5,
    y2: 698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE27F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_648_269",
    x1: 616.5,
    y1: 337,
    x2: 616.5,
    y2: 698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE27F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_648_269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1315,
    height: 1262,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldLogo);
export default __webpack_public_path__ + "static/media/gold_logo.56ebe5ea3ab9b8a88a6ded33c70d650d.svg";
export { ForwardRef as ReactComponent };